/*eslint-disable*/
import { useState } from 'react';
import { Link } from "react-router-dom";
import {
    Navbar,
    NavbarBrand,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    Button,
    UncontrolledDropdown,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleUser } from '@fortawesome/free-solid-svg-icons';
import BasicLoader from '../../common/loader/PlLoader';
import PublicTabOption from './PublicTabOption';
import ProfileImg from '../../../assets/images/empty-logo.svg';

import './roadmap.public.scss';

const PublicNavbar = ({
    hostUrl,
    roadmapLoader,
    publicUserInfo,
    tokenExists,
    publiclLogoutHandler,
    openOverviewModal,
    isOpen,
    toggle,
    navOption,
    changeNavOption,
    companyInfo
}) => {
    const { t } = useTranslation();

    const logout = () => {
        console.log('logout -->');
        publiclLogoutHandler();
        //toggle();
    };

    const {
        name,
        logo,
        changelog_controls,
        show_feature_request,
        roadmap_title,
        roadmap_description,
        feature_request_title,
        feature_request_description
    } = companyInfo;

    const publicRoadmapSettings = {
        show_feature_request,
        roadmap_title,
        roadmap_description,
        feature_request_title,
        feature_request_description
    }

    const userProfileImg = (logo !== 'undefined') ? logo : ProfileImg;

    return (
        <Navbar className="roadmap-navbar-parent" expand="lg">
            {/* logo & company name */}
            <NavbarBrand
                className="roadmap-navbar-brand"
                href={`https://${hostUrl}`}
                style={{ textTransform: 'capitalize' }}
            >
                {
                    roadmapLoader ? (
                        <BasicLoader
                            height={'35px'}
                            width={'120px'}
                        />
                    ) : (
                        <img src={userProfileImg} className="roadmap-logo" />
                    )
                }
                {name}
            </NavbarBrand>

            {/* user dropdown only visible on small devices */}
            {
                tokenExists ? (
                    <div className="mobile-user-option d-md-none">
                        <UncontrolledDropdown nav className="user-dropdown">
                            <DropdownToggle caret tag="span" >
                                <FontAwesomeIcon onClick={() => toggle()} icon={faCircleUser} />
                            </DropdownToggle>

                            <DropdownMenu>
                                <DropdownItem className="dropdown-item" style={{ textTransform: 'lowercase' }}>
                                    {tokenExists?.sub}
                                </DropdownItem>
                                <DropdownItem divider />
                                <DropdownItem dropDownValue='logout' onClick={logout} className="dropdown-item">
                                    {t("logout")}
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                ) : (
                    <Button
                        className="public-nav-btn-login d-sm-none"
                        onClick={() => openOverviewModal('signup')}>{t("login")}/{t("signup")}</Button>
                )
            }

            {/* public tab option */}
            <PublicTabOption
                changeNavOption={changeNavOption}
                navOption={navOption}
                changelog_controls={changelog_controls}
                publicRoadmapSettings={publicRoadmapSettings}
            />

            {/* user dropdown */}
            {
                tokenExists ? (
                    <div className="right-nav-option">
                        {
                            publicUserInfo.type === "protected" && (
                                <Button secondary outline className="dashboard-btn">
                                    <Link to={publicUserInfo.adminLink} className="public-nav-btn">{t("admin_dashboard")}</Link>
                                </Button>
                            )
                        }
                        <UncontrolledDropdown nav className="user-dropdown">

                            <DropdownToggle caret tag="span" >
                                <FontAwesomeIcon onClick={toggle} icon={faCircleUser} />
                            </DropdownToggle>

                            <DropdownMenu>
                                <DropdownItem className="dropdown-item" style={{ textTransform: 'lowercase' }}>
                                    {tokenExists?.sub}
                                </DropdownItem>
                                <DropdownItem divider />
                                <DropdownItem dropDownValue='logout'
                                    onClick={() => logout()}
                                    className="dropdown-item">
                                    {t("logout")}
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>

                ) : (
                    <Button
                        className="public-nav-btn-login d-none d-sm-block"
                        onClick={() => openOverviewModal('signup')}>
                        {t("login")}/{t("signup")}
                    </Button>
                )
            }
        </Navbar>
    );
};

export default PublicNavbar;
